import i18n from 'modules/core/lib/i18n'

export const translations = () => ({
  submit: i18n.t('contract_versions.flows.update.footer.submit'),
})
